
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class BuildingIcon extends Vue {
  @Prop()
  public branding!: string;
}
